var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTeniloHousePath(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 129.20276 130.72804",
    id: "svg530",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs527"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-1.0581197,-0.81762884)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m 76.832974,93.541744 c 7.046304,0.09454 12.669549,5.844777 12.533568,12.817466 v 0 25.18647 H 64.456967 v -25.18647 0 C 64.291407,99.435096 69.836093,93.692683 76.832974,93.541744 Z M 65.781573,0.81762887 c 35.717357,0 64.479317,29.82699213 64.479317,65.88155013 v 64.846501 h -24.89222 v -64.846501 0 c -0.0198,-22.37456 -17.309805,-40.815832 -39.709108,-40.815832 -22.399451,0 -39.691611,18.389568 -39.691611,40.815832 v 0 64.846501 H 1.0581198 V 66.699179 c 0,-36.054558 28.7618352,-65.88155013 64.7234532,-65.88155013 z",
    id: "path16",
    style: {
      fill: "#f8f2ea",
      strokeWidth: 1.73411
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeniloHousePath);
export default __webpack_public_path__ + "static/media/tenilo_house_path.db4c50c354191307c8e67fcc1ee198ba.svg";
export { ForwardRef as ReactComponent };